/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id" endpoint.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { putDecisioningStudioAgentsBaseCreativeCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsBaseCreativeProps,
  PutDecisioningStudioAgentsBaseCreativeRequestBody,
  PutDecisioningStudioAgentsBaseCreativeResult,
} from "./types";

export const putDecisioningStudioAgentsBaseCreative = reactQueryMutationAdapter(
  putDecisioningStudioAgentsBaseCreativeCacheKeys,
  ({
    appGroupId,
    campaignId,
    dsaId,
    messageVariation,
    name,
    writeMode,
  }: PutDecisioningStudioAgentsBaseCreativeProps): Promise<PutDecisioningStudioAgentsBaseCreativeResult> => {
    const body: PutDecisioningStudioAgentsBaseCreativeRequestBody = {
      base_creative_campaign: {
        name,
        message_variation: messageVariation,
        ...(writeMode !== undefined ? { write_mode: writeMode } : {}),
      },
    };

    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/base_creatives/${campaignId}`,
      "PUT",
      body,
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
